import { styled, css } from 'styled-components';
export const StyledItem = styled.button.attrs(() => ({
    type: 'button',
})) `
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding: 8px 16px;
  height: 36px;
  border: none;
  border-left: 1px solid ${({ theme, $allDisabled }) => ($allDisabled ? theme.colors.grey05_3 : theme.colors.grey30_1)};
  border-top: 1px solid ${({ theme, $allDisabled }) => ($allDisabled ? theme.colors.grey05_3 : theme.colors.grey30_1)};
  box-sizing: border-box;

  &:nth-child(${({ $columns }) => $columns}n + 1) {
    border-left: none;
  }

  &:nth-child(-n + ${({ $columns }) => $columns}) {
    border-top: none;
  }

  background: ${({ $checked, disabled, theme }) => {
    if ($checked && disabled)
        return theme.colors.grey70_1;
    if (!$checked && disabled)
        return theme.colors.grey05_3;
    return theme.colors.grey00_1;
}};
  color: ${({ $checked, disabled, theme }) => {
    if ($checked && disabled)
        return theme.colors.grey30_1;
    if (!$checked && disabled)
        return theme.colors.grey70_3;
    if ($checked && !disabled)
        return theme.colors.black_1;
    return theme.colors.grey100_1;
}};

  &:after {
    content: '';
    height: 2px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background: ${({ $checked, disabled, theme }) => {
    if ($checked && disabled)
        return theme.colors.grey70_1;
    if ($checked && !disabled)
        return theme.colors.main;
    return '';
}};
  }

  &:hover {
    ${({ $checked, disabled }) => $checked
    ? css `
            cursor: ${disabled ? 'not-allowed' : 'default'};
          `
    : css `
            cursor: ${disabled ? 'not-allowed' : 'pointer'};
          `}
  }

  &:focus-visible {
    outline: 0;
  }

  ${({ theme }) => theme.typography.textMedium};
  ${({ theme }) => theme.typography.weightMedium}
`;
